<template>
    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.642 15.695c.56 0 1.015-.174 1.363-.522.348-.348.522-.793.522-1.334V10.04h4.06c.406 0 .753-.115 1.04-.344l.12-.106c.31-.3.464-.681.464-1.145 0-.464-.155-.846-.464-1.145-.31-.3-.696-.45-1.16-.45h-4.06V2.529c0-.474-.13-.873-.389-1.199l-.118-.135C8.68.847 8.232.673 7.67.673c-.541 0-.996.174-1.363.522-.367.348-.551.793-.551 1.334V6.85H1.784c-.406 0-.753.111-1.04.333l-.12.102c-.31.29-.464.667-.464 1.131 0 .464.155.85.464 1.16.31.31.696.464 1.16.464h3.973v3.799c0 .481.141.886.424 1.214l.112.12c.358.348.808.522 1.349.522z" fill="#033D89" fill-rule="nonzero"/>
    </svg>
</template>

<script>
export default {
    name: 'IconPlus',
};
</script>
